import messages from '../../constants/messages';
import { ALL_ROLES } from '../../constants/role';
import { ALL_PLANS, PLAN_TYPE } from '../../constants/subscription';

export const getCOLUMN_1 = ({ isNew }) => ({
  eartag_management_id: {
    id: 'eartag_management_id',
    is_editable: true,
    label: 'Mgmt Tag ID',
    rules: [
      {
        required: true,
        message: messages.FIELD_REQUIRED('Mgmt Tag ID')
      }
    ],
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  kraal_tag_id: {
    id: 'kraal_tag_id',
    is_editable: false,
    label: 'Kraal Tag ID',
    visibility: { plans: [PLAN_TYPE.TRACKING, PLAN_TYPE.COMPLETED], roles: ALL_ROLES }
  },
  lastReading: {
    id: 'lastReading',
    is_editable: false,
    label: 'Last Reading',
    visibility: { plans: [PLAN_TYPE.TRACKING, PLAN_TYPE.COMPLETED], roles: ALL_ROLES }
  },
  connectionStatus: {
    id: 'connectionStatus',
    is_editable: false,
    label: 'Connection Status',
    visibility: { plans: [PLAN_TYPE.TRACKING, PLAN_TYPE.COMPLETED], roles: ALL_ROLES }
  },
  eartag_official_id: {
    id: 'eartag_official_id',
    is_editable: true,
    label: 'Official Tag ID',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  brand: {
    id: 'brand',
    is_editable: true,
    label: 'Brand',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  ear_mark: {
    id: 'ear_mark',
    is_editable: true,
    label: 'Ear Mark',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  specie: {
    id: 'specie',
    is_editable: true,
    label: 'Specie',
    rules: [
      {
        required: true,
        message: messages.FIELD_REQUIRED('Specie')
      }
    ],
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  breed: {
    id: 'breed',
    is_editable: true,
    label: 'Breed',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  stock_type: {
    id: 'stock_type',
    is_editable: true,
    label: 'Livestock Type',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  sex: {
    id: 'sex',
    is_editable: true,
    label: 'Sex',
    rules: [
      {
        required: true,
        message: messages.FIELD_REQUIRED('Sex')
      }
    ],
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  colour: {
    id: 'colour',
    is_editable: true,
    label: 'Colour',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  dob_at: {
    id: 'dob_at',
    is_editable: true,
    label: 'DOB',
    rules: [
      {
        required: true,
        message: messages.FIELD_REQUIRED('DOB')
      }
    ],
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  polled_horned: {
    id: 'polled_horned',
    is_editable: true,
    label: 'Polled/Horned',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  name: {
    id: 'name',
    is_editable: true,
    label: 'Description',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  farm: isNew
    ? {
        id: 'farm_id',
        is_editable: true,
        label: 'Farm',
        rules: [
          {
            required: true,
            message: messages.FIELD_REQUIRED('Farm')
          }
        ],
        visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
      }
    : {
        id: 'farm_id',
        label: 'Farm',
        visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
      },
  geofences: isNew
    ? {
        id: 'geofence_ids',
        is_editable: true,
        label: 'Assigned Pasture',
        visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
      }
    : {
        id: 'geofence_ids',
        label: 'Assigned Pasture',
        visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
      },
  sire_id: {
    id: 'sire_id',
    is_editable: true,
    label: 'Sire ID',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  dam_id: {
    id: 'dam_id',
    is_editable: true,
    label: 'Dam ID',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  }
});

export const COLUMN_2 = {
  breeding_status: {
    id: 'breedingStatus',
    is_editable: false,
    label: 'Breeding Status',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  calf_livestock_identifier: {
    id: 'calfLivestockId',
    is_editable: false,
    label: 'Calf ID',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  calf_age: {
    id: 'calfAge',
    is_editable: false,
    label: 'Calf Age',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  purchase_date: {
    id: 'purchase_date',
    is_editable: true,
    label: 'Purchase Date',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  purchased_from: {
    id: 'purchased_from',
    is_editable: true,
    label: 'Purchased From',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['purchase_date'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const purchaseDate = getFieldValue('purchase_date');
          if (purchaseDate && !value) {
            return Promise.reject(new Error('Purchase From is required when Purchased Date is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  purchased_where: {
    id: 'purchased_where',
    is_editable: true,
    label: 'Purchased Location',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['purchase_date'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const purchaseDate = getFieldValue('purchase_date');
          if (purchaseDate && !value) {
            return Promise.reject(new Error('Purchase Location is required when Purchased Date is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  purchase_notes: {
    id: 'purchase_notes',
    is_editable: true,
    label: 'Purchase Notes',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  date_sold: {
    id: 'date_sold',
    is_editable: true,
    label: 'Date Sold',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['sold_to'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const soldTo = getFieldValue('sold_to');
          if (soldTo && !value) {
            return Promise.reject(new Error('Date Sold is required when Date To is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  sold_to: {
    id: 'sold_to',
    is_editable: true,
    label: 'Sold To',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['date_sold'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const soldDate = getFieldValue('date_sold');
          if (soldDate && !value) {
            return Promise.reject(new Error('Sold To is required when Date Sold is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  sold_where: {
    id: 'sold_where',
    is_editable: true,
    label: 'Sold Location',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['date_sold'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const soldDate = getFieldValue('date_sold');
          if (soldDate && !value) {
            return Promise.reject(new Error('Sold Location is required when Date Sold is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  loss_date: {
    id: 'loss_date',
    is_editable: true,
    label: 'Loss Date',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['loss_reason'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const lossReason = getFieldValue('loss_reason');
          if (lossReason && !value) {
            return Promise.reject(new Error('Loss Date is required when Loss Reason is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  loss_reason: {
    id: 'loss_reason',
    is_editable: true,
    label: 'Loss Reason',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES },
    dependencies: ['loss_date'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          const lossDate = getFieldValue('loss_date');
          if (lossDate && !value) {
            return Promise.reject(new Error('Loss Reason is required when Loss Date is specified.'));
          }

          return Promise.resolve();
        }
      })
    ]
  },
  comments: {
    id: 'comments',
    is_editable: true,
    label: 'Comments',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  weight: {
    id: 'weight',
    is_editable: true,
    label: 'Weight',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  minor_measurement_type: {
    id: 'minor_measurement_type',
    is_editable: true,
    label: 'Minor Measurement Type',
    dependencies: ['weight'],
    rules: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (getFieldValue('weight') && !value) {
            return Promise.reject();
          }

          return Promise.resolve();
        }
      })
    ],
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  age: {
    id: 'age',
    is_editable: false,
    label: 'Age',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  }
};

export const COLUMN_3 = {
  physical_group: {
    id: 'label_ids',
    is_editable: true,
    label: 'Physical Group',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  },
  virtual_group: {
    id: 'group_ids',
    is_editable: true,
    label: 'Virtual Groups',
    visibility: { plans: ALL_PLANS, roles: ALL_ROLES }
  }
};
